import { render, staticRenderFns } from "./UkrposhtaFilter.vue?vue&type=template&id=44732570&scoped=true"
import script from "./UkrposhtaFilter.vue?vue&type=script&lang=js"
export * from "./UkrposhtaFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44732570",
  null
  
)

export default component.exports